<template>
  <Head title="Login" />
  <div class="login-page-wrapper">
    <flash-messages />
    
    <div class="login-logo">
      <Link :href="route('home')">
        <img src="/images/logo-coremehub-icon.png" alt="CoremeHub" class="logo-img" />
        <span>CoremeHub</span>
      </Link>
    </div>

    <div class="login-top-links">
      <a href="https://coremehub.com.br">Ir para o site</a> | <a href="#">Ajuda</a>
    </div>

    <div class="login-auth-box">
      <h1 class="login-auth-title">CoremeHub<br>Login - Support Center!</h1>

      <form @submit.prevent="login">
        <div class="login-form-group">
          <text-input 
            v-model="form.email" 
            :error="form.errors.email" 
            label="" 
            type="email" 
            placeholder="Seu email"
            autofocus 
            autocapitalize="off" 
          />
        </div>
        
        <div class="login-form-group">
          <text-input 
            v-model="form.password" 
            :error="form.errors.password" 
            label="" 
            type="password" 
            placeholder="Sua senha"
          />
        </div>

        <div class="login-form-options">
          <label class="login-checkbox-label">
            <input id="remember" v-model="form.remember" type="checkbox" />
            <span>Lembrar</span>
          </label>
          <Link :href="route('password.reset')" class="login-forgot-link">Esqueceu sua senha?</Link>
        </div>

        <loading-button 
          :loading="form.processing" 
          class="login-submit-btn" 
          type="submit"
        >
          {{ __('Entrar') }}
        </loading-button>
        
        <p class="login-footer-note">
          Não tem uma conta? <Link :href="route('register')" class="login-register-link">{{ __('Cadastrar-se') }}</Link>
        </p>
      </form>

      <div class="login-demo-section" v-if="is_demo">
        <h2 class="login-demo-title">Login As:</h2>
        <div class="login-demo-buttons">
          <button class="login-demo-btn" @click="autofillLogin($event, 'admin')">Admin</button>
          <button class="login-demo-btn" @click="autofillLogin($event, 'manager')">Manager</button>
          <button class="login-demo-btn" @click="autofillLogin($event, 'customer')">Customer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Head, Link } from '@inertiajs/inertia-vue3'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
    FlashMessages,
    LoadingButton,
    TextInput,
    Head,
    Link,
  },
  props: {
    is_demo: Number
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  mounted() {
    // Aplica background aleatório
    const bgImages = [
      '/images/bg/medico1.jpg',
      '/images/bg/medico2.jpg',
      '/images/bg/medico3.jpg',
      '/images/bg/medico4.jpg'
    ]
    const randomBg = bgImages[Math.floor(Math.random() * bgImages.length)]
    const style = document.createElement('style')
    style.textContent = `.login-page-wrapper::before { background-image: url('${randomBg}'); }`
    document.head.appendChild(style)
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
    autofillLogin(e, role){
      e.preventDefault()
      const roleEmails = { 'admin': 'john.due.helo@mail.com', 'manager': 'robert.slaughter@mail.com', 'customer' : 'mmarks@example.com'}
      this.form.email = roleEmails[role]
      this.form.password = 'secret'
      this.login();
    }
  }
}
</script>
